<div class="settings-container">  
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'settings.title' | translate }}</h2>
  </div>

  <div *ngIf="!settings">
    <div class="error-message" *ngIf="formError">{{ formError | translate: formErrorParams }}</div>    
  </div>

  <div *ngIf="settings">
    <div class="settings-form">      
      <div class="settings-panel">
        <label>{{ 'common.name' | translate }}
          <input type="text" [(ngModel)]="settings.name" />
        </label>
        <label>{{ 'common.description' | translate }}
          <input type="text" [(ngModel)]="settings.description" />
        </label>
        <label>{{ 'settings.theme' | translate }}
          <select [(ngModel)]="settings.theme">
            <option value="standard">{{ 'settings.theme.standard' | translate }}</option>
            <option value="irrigation">{{ 'settings.theme.irrigation' | translate }}</option>
            <option value="light">{{ 'settings.theme.light' | translate }}</option>
          </select>
        </label>
      </div>
      
      <div class="settings-panel">
        <div class="modal-body">          
          <div class="settings-section">
            <h4>Ethernet</h4>            
            <div *ngIf="settings.eth">
              <div class="form-group inline">
                <label for="deth">DHCP</label>
                <label class="switch" *ngIf="settings.eth">
                  <input type="checkbox" id="deth" [(ngModel)]="settings.eth.dhcp"/>
                  <span class="slider round"></span>
                </label>
              </div>   
              <div class="net-row" *ngIf="settings.eth && !settings.eth.dhcp">
                <label>{{ 'settings.net.ip' | translate }}
                  <input type="text" [(ngModel)]="settings.eth.ip" />
                </label>
                <label>{{ 'settings.net.netmask' | translate }}
                  <input type="text" [(ngModel)]="settings.eth.mask" />
                </label>              
                <label>{{ 'settings.net.gateway' | translate }}
                  <input type="text" [(ngModel)]="settings.eth.gw" />
                </label>
                <label>{{ 'settings.net.dns' | translate }}
                  <input type="text" [(ngModel)]="settings.eth.dns" />
                </label>
              </div>                                        
            </div>
          </div>  

          <div class="settings-section">            
            <h4>WiFi</h4>
            <div class="form-group inline">
              <label for="wifi">{{ 'common.enabled' | translate }}</label>
              <label class="switch" *ngIf="settings.wifi">
                <input type="checkbox" id="wifi" [(ngModel)]="settings.wifi.enabled"/>
                <span class="slider round"></span>
              </label>
            </div>              
            <div class="net-row" *ngIf="settings.wifi && settings.wifi.enabled">
              <label>{{ 'settings.net.ssid' | translate }}
                <input type="text" [(ngModel)]="settings.wifi.ssid" />
              </label>
              <label>{{ 'settings.net.password' | translate }}
                <input type="text" [(ngModel)]="settings.wifi.pass" />
              </label>
            </div>
            <div class="form-group inline" *ngIf="settings.wifi && settings.wifi.enabled">
              <label for="dwifi">DHCP</label>
              <label class="switch" >
                <input type="checkbox" id="dwifi" [(ngModel)]="settings.wifi.dhcp"/>
                <span class="slider round"></span>
              </label>
            </div>                          
            <div class="net-row" *ngIf="settings.wifi && settings.wifi.enabled && !settings.wifi.dhcp">
              <label>{{ 'settings.net.ip' | translate }}
                <input type="text" mask="IP" [(ngModel)]="settings.wifi.ip" />
              </label>
              <label>{{ 'settings.net.netmask' | translate }}
                <input type="text" [(ngModel)]="settings.wifi.mask" />
              </label>
            </div>
            <div class="net-row" *ngIf="settings.wifi && settings.wifi.enabled && !settings.wifi.dhcp">
              <label>{{ 'settings.net.gateway' | translate }}
                <input type="text" [(ngModel)]="settings.wifi.gw" />
              </label>
              <label>{{ 'settings.net.dns' | translate }}
                <input type="text" [(ngModel)]="settings.wifi.dns" />
              </label>
            </div>            
          </div>

          <div class="settings-section">            
            <h4>Cloud</h4>
            <div class="form-group inline">
              <label for="cloud">{{ 'common.enabled' | translate }}</label>
              <label class="switch" *ngIf="settings.cloud">
                <input type="checkbox" id="cloud" [(ngModel)]="settings.cloud.enabled"/>
                <span class="slider round"></span>
              </label>
            </div>              
            <div class="net-row" *ngIf="settings.cloud && settings.cloud.enabled">
              <label>{{ 'settings.net.address' | translate }}
                <input type="text" [(ngModel)]="settings.cloud.address" />
              </label>              
            </div>            
          </div>

          <div class="settings-section">            
            <h4>OTA</h4>            
            <div class="net-row" *ngIf="settings.ota">
              <label>{{ 'settings.net.address' | translate }}
                <input type="text" [(ngModel)]="settings.ota.address" />
              </label>              
            </div>    
          </div>

          <div class="settings-section">            
            <h4>MQTT</h4>
            <div class="form-group inline">
              <label for="mqtt">{{ 'common.enabled' | translate }}</label>
              <label class="switch" *ngIf="settings.mqtt">
                <input type="checkbox" id="mqtt" [(ngModel)]="settings.mqtt.enabled"/>
                <span class="slider round"></span>
              </label>
            </div>              
            <div class="net-row" *ngIf="settings.mqtt && settings.mqtt.enabled">
              <label>{{ 'settings.net.address' | translate }}
                <input type="text" [(ngModel)]="settings.mqtt.address" />
              </label>                            
            </div>            
          </div>

          <div class="settings-section">            
            <h4>NTP</h4>
            <div class="net-row" *ngIf="settings.ntp">
              <label>{{ 'settings.net.address' | translate }}
                <input type="text" [(ngModel)]="settings.ntp.address" />
              </label>              
              <label>{{ 'settings.net.tz' | translate }}
                <input type="text" [(ngModel)]="settings.ntp.tz" />
              </label>
            </div>            
          </div>

          <div class="settings-section" *ngIf="isRCV2">
            <h4>{{ 'settings.relay_hold.title' | translate }}</h4>
            <div class="net-row">
              <div class="hint">{{ 'settings.relay_hold.hint' | translate }}</div>
              <div *ngIf="relayHoldEntries.length === 0" class="hint">{{ 'settings.relay_hold.all_default' | translate }}</div>
              <div class="custom-grid" *ngFor="let h of relayHoldEntries; let i = index">
                <div>
                  <select [(ngModel)]="h.output">
                    <option *ngFor="let o of outputRange()" [ngValue]="o">{{ 'settings.relay_hold.relay' | translate: { n: o } }}</option>
                  </select>
                  <input type="number" min="0" max="4095" placeholder="PWM" [(ngModel)]="h.pwm" />
                </div>
                <button class="remove-button" (click)="removeRelayHold(i)" [title]="'settings.relay_hold.remove' | translate">
                  <img src="assets/icons/close.svg" width="20" height="20" [alt]="'settings.relay_hold.remove' | translate" />
                </button>
              </div>
              <button class="add-button" (click)="addRelayHold()">
                <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
                {{ 'settings.relay_hold.add' | translate }}
              </button>
            </div>
          </div>

      </div>
      <div class="error-message" *ngIf="formError">{{ formError | translate: formErrorParams }}</div>    
    </div>  

    <div class="actions">      
      <button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
      <button class="save-button" (click)="saveSettings()">{{ 'common.save' | translate }}</button>
    </div>
  </div>
</div>